"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformPaymentTypeToString = transformPaymentTypeToString;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function transformPaymentTypeToString(type) {
    switch (type) {
        case legacy_enums_1.PaymentType.Mangopay:
            return "mangopay";
        case legacy_enums_1.PaymentType.Paypal:
            return "paypal";
        case legacy_enums_1.PaymentType.Cash:
            return "cash";
        case legacy_enums_1.PaymentType.StatementOfBooking:
            return "statement of booking";
        case legacy_enums_1.PaymentType.BankTransaction:
            return "bank transaction";
        case legacy_enums_1.PaymentType.Other:
            return "other";
        case legacy_enums_1.PaymentType.Checkout:
            return "checkout";
        case legacy_enums_1.PaymentType.Stripe:
            return "stripe";
        default:
            return "unknown payment type";
    }
}
//# sourceMappingURL=transformPaymentTypeToString.js.map